import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { postDatosContacto } from "../actions";
import LoadingViewGears from "~styled/loadingView/LoadingViewGears";

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => ({
    currentState: state,
  }));

export const SendPostSolicitudEmisionStep = () => {
  const dispatch = useDispatch();
  const { currentState } = useReduxSelector();
  const { sendPostSolicitudEmision } = currentState;
  useEffect(() => {
    if (sendPostSolicitudEmision) {
      dispatch(postDatosContacto(currentState));
    }

    //eslint-disable-next-line
  }, [dispatch]);

  return <LoadingViewGears />;
};
